"use client"

import { useFaq as _useFaq, type FaqItem, type FaqCategory } from "@sw-business-solutions/cst-mobikart-core/hooks/use-faq"
import { faqData, faqCategories } from "@/data/faq-data"

export type { FaqItem, FaqCategory }

interface UseFaqOptions {
  initialCategory?: string
  useCategories?: boolean
}

export function useFaq(opts: UseFaqOptions = {}) {
  return _useFaq({ faqData, faqCategories, ...opts })
}
